import { useTranslation } from 'react-i18next';

type useEventPlacesProps = {
  isOpen?: boolean;
  remainingEntries?: string;
}

export const useEventPlaces = ({ isOpen, remainingEntries }: useEventPlacesProps) => {
  const { t } = useTranslation();

  const places = () => {
    if (isOpen || remainingEntries === 'NaN') return t('event_screen.free_access');

    if (!isOpen && remainingEntries && parseInt(remainingEntries, 10) === 0) return t('event_screen.no_vacancy');

    if (remainingEntries && parseInt(remainingEntries, 10) > 0) {
      return `${remainingEntries} ${t('event_screen.vacancy')}`;
    }

    return null;
  };

  const freeAccess = Boolean(isOpen);

  return { places, freeAccess, isOpen: Boolean(isOpen) };
};
